import { DatePicker, FormField, todayIso, useToast } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDialog } from '../../../app/FormDialog';
import { formErrors } from '../../../lib/errors';
import { useEndTreatment, type Treatment } from '../api';

/** Ends a running long-term treatment (TRT-005). */
export function EndTreatmentDialog({
  open,
  onClose,
  treatment,
}: {
  open: boolean;
  onClose: () => void;
  treatment: Treatment;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const end = useEndTreatment();
  const [on, setOn] = useState(todayIso());
  const errors = formErrors(end.error, { on: ['treatment.ends_before_start'] });
  const close = () => {
    end.reset();
    onClose();
  };
  return (
    <FormDialog
      open={open}
      onClose={close}
      title={t('apiary.treatment.endTitle')}
      description={`${treatment.method_name} · ${treatment.colony.name}`}
      size="sm"
      submitLabel={t('apiary.treatment.end')}
      pending={end.isPending}
      error={errors.general}
      onSubmit={() =>
        end.mutate(
          { id: treatment.id, on },
          {
            onSuccess: () => {
              toast.show(t('apiary.treatment.ended'));
              close();
            },
          },
        )
      }
    >
      <FormField label={t('apiary.treatment.endDate')} error={errors.field.on}>
        {(p) => <DatePicker {...p} value={on} min={treatment.started_on} onChange={setOn} />}
      </FormField>
    </FormDialog>
  );
}
